import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const proTip = {
  element:
    '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div.preview > div > button:nth-child(2)',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.PRO_TIP.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.PRO_TIP.DESCRIPTION'),
    side: 'left',
    align: 'end',
    onPopoverRender: () => {
      const pinButton = document.querySelector(
        '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div.preview > div > button:nth-child(2)'
      );

      if (pinButton) {
        pinButton.click();
      }
    },
    onPrevClick: () => {
      const pinButton = document.querySelector(
        '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div.preview > div > button:nth-child(2)'
      );

      if (pinButton) {
        pinButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 50);
      }
    },
    onNextClick: () => {
      const editHtmlButton = document.querySelector(
        '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div > div > button'
      );
      const pinButton = document.querySelector(
        '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div.preview > div > button:nth-child(2)'
      );

      if (pinButton) {
        pinButton.click();
      }

      if (editHtmlButton) {
        editHtmlButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 50);
      }
    }
  }
};

export const unparsedPreview = {
  element: '.editor .preview .raw-preview',
  popover: {
    title: 'Unparsed Preview',
    description: 'Change the preview to show the unparsed version of the template.',
    side: 'bottom',
    align: 'center'
  }
};

export const darkMode = {
  element: '.editor .preview .dark-preview',
  popover: {
    title: 'Dark Mode Preview',
    description: 'Toggle the dark mode preview to see how your signature looks in dark mode.',
    side: 'bottom',
    align: 'center'
  }
};
